import Metamask from '../../../../common/images/metamask/metamask-fox.png';
import Wc from '../../../../common/images/wallet_connect/wallet-connect.jpeg';
import type { WalletMeta } from './types';

export const WALLETS_META_MAP: Record<string, WalletMeta> = {
  metaMaskSDK: {
    name: 'MetaMask',
    icon: Metamask,
  },
  walletConnect: {
    name: 'WalletConnect',
    icon: Wc,
  },
};
